import {
  Breadcrumb,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  BreadcrumbItem as KitBreadcrumbItem,
} from '@ibsys/kit';
import { FC, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { useMainLayout } from '../model';

export const Breadcrumbs: FC<{ className?: string }> = ({ className }) => {
  const {
    breadcrumbs: { breadcrumbs },
  } = useMainLayout();

  if (!breadcrumbs.length) return null;

  return (
    <Breadcrumb className={className}>
      <BreadcrumbList>
        {breadcrumbs.map((item, idx) => (
          <Fragment key={`${item.label}-${idx}`}>
            {idx > 0 && <BreadcrumbSeparator />}
            {item.isCurrent || !item.path ? (
              <KitBreadcrumbItem>
                <BreadcrumbPage className={'text-sidebar-foreground'}>{item.label}</BreadcrumbPage>
              </KitBreadcrumbItem>
            ) : (
              <KitBreadcrumbItem>
                <BreadcrumbLink asChild className={'text-sidebar-foreground'}>
                  <NavLink to={item.path}>{item.label}</NavLink>
                </BreadcrumbLink>
              </KitBreadcrumbItem>
            )}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
